import CustomerService from './customer-service';
export default CustomerService;
